// extracted by mini-css-extract-plugin
export var quantityInput = "_fn-0";